import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TimeOfDay } from 'src/app/model/opening-hours';

const HOURS = Array.from({ length: 25 }, (_, i) => i);
const MINUTES = Array.from({ length: 12 }, (_, i) => i * 5);
const MINUTE_ZERO_ONLY = [0];

function snapMinute(m: number): number {
  return Math.round(m / 5) * 5;
}

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

@Component({
  selector: 'gymfinder-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
  standalone: false,
})
export class TimeInputComponent {
  @Input()
  set time(val: TimeOfDay) {
    this.hour = val.hour;
    this.minute = snapMinute(val.minute);
    if (this.hour === 24) this.minute = 0;
  }

  @Input() disabled = false;

  @Output() timeChange = new EventEmitter<TimeOfDay>();

  hour = 8;
  minute = 0;
  hours = HOURS;

  get minutes(): number[] {
    return this.hour === 24 ? MINUTE_ZERO_ONLY : MINUTES;
  }

  pad = pad;

  onHourChange(h: number): void {
    this.hour = h;
    if (h === 24) this.minute = 0;
    this.emit();
  }

  onMinuteChange(m: number): void {
    this.minute = m;
    this.emit();
  }

  private emit(): void {
    this.timeChange.emit({ hour: this.hour, minute: this.minute });
  }
}
